import { ObjectValuesType } from 'addiction-components';

export const AssetDetail = {
	CATEGORY: 'CATEGORY',
	TAG: 'TAG',
} as const;
export type AssetDetail = ObjectValuesType<typeof AssetDetail>;
